var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Container',{staticClass:"section",class:{'with-aside': _vm.withAside}},[_c('div',{staticClass:"inner"},[_c('div',{staticClass:"column text"},[_vm._t("default")],2),(_vm.withAside)?_c('div',{staticClass:"column aside"},[_vm._t("aside")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }